import React from 'react'
import logo from '../../logo.svg'

class Show extends React.Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">Welcome to Whisperlab</h1>
        </header>
        <p className="App-intro">
          feel free to contact us
          <br/>
          <br/>
          support@whisperlab.com
        </p>
      </div>
    )
  }
}

export default Show



// WEBPACK FOOTER //
// ./src/screens/Home/index.js